/* Collection grid card — image overlay buttons.
   Quick add (+): posts to the cart and re-renders/opens the theme cart drawer.
   Favorite (heart): persists product handles in localStorage, scoped per logged-in
   customer (data-wl-scope) so each account keeps its own list on this device. */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'carmine_wishlist_';

  function storageKey(scope) {
    return STORAGE_PREFIX + (scope || 'guest');
  }

  function readList(scope) {
    try {
      var raw = localStorage.getItem(storageKey(scope));
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(scope, list) {
    try {
      localStorage.setItem(storageKey(scope), JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode) — heart still toggles for the session */
    }
  }

  function applyWishlistStates(root) {
    (root || document).querySelectorAll('.cgp-wishlist').forEach(function (btn) {
      var active = readList(btn.dataset.wlScope).indexOf(btn.dataset.productHandle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toggleWishlist(btn) {
    var scope = btn.dataset.wlScope;
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    var list = readList(scope);
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    writeList(scope, list);
    applyWishlistStates();
  }

  function quickAdd(btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var variantId = Number(btn.dataset.variantId);
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    btn.classList.add('is-loading');

    var body = { id: variantId, quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        btn.classList.remove('is-loading');
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'Could not add to cart');
        }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1600);

        if (
          drawer &&
          result.data.sections &&
          typeof drawer.renderContents === 'function' &&
          typeof window.updateCartDrawer === 'function'
        ) {
          drawer.renderContents(result.data); // re-renders drawer + icon bubble, opens drawer
        } else if (drawer) {
          document.dispatchEvent(new CustomEvent('cart:ajax-update', { detail: {} }));
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        console.error('[cgp-overlay] quick add failed:', err);
      });
  }

  document.addEventListener('click', function (e) {
    var wl = e.target.closest && e.target.closest('.cgp-wishlist');
    var qa = e.target.closest && e.target.closest('.cgp-quickadd');
    if (!wl && !qa) return;
    /* cards may be wrapped in an <a class="product-link"> — keep the click on the button */
    e.preventDefault();
    e.stopPropagation();
    if (wl) toggleWishlist(wl);
    if (qa) quickAdd(qa);
  }, true);

  /* re-apply heart states when the grid re-renders (filtering / pagination) */
  var debounce;
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        clearTimeout(debounce);
        debounce = setTimeout(function () { applyWishlistStates(); }, 100);
        return;
      }
    }
  });

  function init() {
    applyWishlistStates();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
